<template>
 <div>
    <Step1 v-if="$store.state.currentStep == '1'"></Step1>
    <!-- <Step2 v-else-if="$store.state.currentStep=='2'"></Step2> -->
    <PaymentOptions  v-else-if="$store.state.currentStep=='3'"/>
    <SuccessComponent v-if="showSuccessComponent"/>
    <ErrorComponent v-if="showErrorComponent"/>
    <WarningModal v-if="showWarningModal"/>
    <Loader />
  </div>
</template>

<script>
import Step1 from './components/Step1'
// import Step2 from './components/Step2'
import Loader from '@/components/Loader.vue'
import PaymentOptions from './components/payment-options.vue'
import SuccessComponent from './components/success.vue'
import ErrorComponent from "./components/error.vue"
import WarningModal from './components/WarningModal'
export default {
  name: 'App',
  components: {
    Step1,
    // Step2,
    Loader,
    PaymentOptions,
    SuccessComponent,
    ErrorComponent,
    WarningModal
  },
  data: function() {
    return {
     
    }
  },
  created(){
      this.checkUrlStatus();

      let locale = document.getElementsByTagName("BODY")[0].getAttribute("data-locale")

      this.$store.commit("setLocale", locale);
   },
  computed: {
      showSuccessComponent(){
         return this.$store.state.showSuccessComponent;
      },
      showErrorComponent(){
         return this.$store.state.showErrorComponent;
      },
      showSavedCardComponent(){
        return this.$store.state.showSavedCardComponent;
      },
      showWarningModal(){
        return this.$store.state.showWarningModal;
      },
      locale(){
        return this.$store.state.locale;
      }
   },
   methods: {
     checkUrlStatus(){
        this.$store.commit('showLoader');
        var urlParams = new URLSearchParams(window.location.search);
        var status = urlParams.get('status');
        var errorFromBank = urlParams.get('errorFromBank');
        if (status != null){
          if (status == 'OK'){ 
            var msisdn = urlParams.get('msisdn');
            var amount = urlParams.get('amount');
            var transactionCode = urlParams.get('transactionCode');
            amount= Math.round(amount);
            this.$store.commit("setUrlParamMsisdn", msisdn);
            this.$store.commit("setUrlParamAmount", amount);
            this.$store.commit("setUrlParamTransactionCode", transactionCode);

            $(document).on("initDataLayer", function () {
              var dataLayerObj = {
                "event": "topup-online",
                "currency": "EUR",
                "value": amount.toFixed(2),
                "loggedin": "no",
              }
              handleDataLayer.init();
              handleDataLayer.pushDataLayer(dataLayerObj);
              
            })

            this.$store.commit('showSuccessComponent', true);
            this.$store.commit('hideLoader');
            console.log("successfull transaction")
          }else if (status == 'NOK'){
            this.$store.commit('setErrorFromBank', errorFromBank);
            this.$store.commit('showErrorComponent', true);
            console.log("unsuccessfull transaction")
            this.$store.commit('hideLoader');

          }
        }else{
          this.checkSessionStorage();
        } 
      },
      checkSessionStorage(){
        //  var url = new URL(window.location.href);
        //  var token = url.searchParams.get("token");
        var anonymous_infos_F2G =  JSON.parse(sessionStorage.getItem("anonymous_infos_F2G"));
        //var token = sessionStorage.getItem('token');
        if(anonymous_infos_F2G != null && anonymous_infos_F2G !=undefined){
          var activeFlowState = sessionStorage.getItem('activeFlow_' + "F2G_"+ anonymous_infos_F2G.token);

          if(activeFlowState == "false"){
          this.$store.commit("setActiveFlow", false);
          this.$store.commit('showErrorComponent', true);
          }else{
            if(anonymous_infos_F2G.currentStep === "3" && (anonymous_infos_F2G.token != null || anonymous_infos_F2G.token != undefined) && (anonymous_infos_F2G.msisdn != null || anonymous_infos_F2G.msisdn != undefined) && (anonymous_infos_F2G.email != null || anonymous_infos_F2G.email != undefined)){
              this.$store.commit("setToken", anonymous_infos_F2G.token);
              this.$store.commit("setMsisdn", anonymous_infos_F2G.msisdn);
              this.$store.commit("setEmail", anonymous_infos_F2G.email);
              this.$store.commit("changeStep", '3');
            }
          }
        }
        
        this.$store.commit('hideLoader');

      },
  }
}
</script>

<style>

</style>
